/**
 * Error responses follow RFC 9457 (application/problem+json) with a stable `code`
 * that clients switch on. Never switch on `title` or `detail`: they are for people.
 */
export const ERROR_CODES = [
  "VALIDATION_FAILED",
  "INVALID_CREDENTIALS",
  "TOO_MANY_ATTEMPTS",
  "SIGNING_CODE_RECENTLY_SENT",
  "UNAUTHENTICATED",
  "SESSION_EXPIRED",
  "FORBIDDEN",
  "PASSWORD_CHANGE_REQUIRED",
  "MFA_CHALLENGE_EXPIRED",
  "NOT_FOUND",
  "CONFLICT",
  "SETUP_INCOMPLETE",
  "AUTHZ_UNAVAILABLE",
  "EMAIL_UNAVAILABLE",
  "ADDRESS_SEARCH_UNAVAILABLE",
  "INTERNAL",
] as const;

export type ErrorCode = (typeof ERROR_CODES)[number];

export interface FieldError {
  /** Dot path of the invalid field, e.g. "guardianPhone". Empty for form-level errors. */
  path: string;
  message: string;
}

export interface Problem {
  type: string;
  title: string;
  status: number;
  code: ErrorCode;
  detail?: string;
  requestId?: string;
  errors?: FieldError[];
}

export function isProblem(value: unknown): value is Problem {
  if (typeof value !== "object" || value === null) return false;
  const candidate = value as Record<string, unknown>;
  return (
    typeof candidate.status === "number" &&
    typeof candidate.code === "string" &&
    (ERROR_CODES as readonly string[]).includes(candidate.code)
  );
}
